import { NOTIFICATION_LIST } from '../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case NOTIFICATION_LIST.LOAD:
      return {
        ...state,
        loading: true,
      };
    case NOTIFICATION_LIST.SUCCESS:
      return {
        ...state,
        loading: false,
        data: payload,
      };
    case NOTIFICATION_LIST.FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    default:
      return state;
  }
}
